export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const GET_LIVE_FEED = "GET_LIVE_FEED";
export const GET_TRANSACTION_STATS = "GET_TRANSACTION_STATS";
export const NEW_TRANSACTION = "NEW_TRANSACTION";
